import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetInvoiceSidebarAmountDueQueryVariables = Types.Exact<{
  rooftopId?: Types.InputMaybe<Types.Scalars['bigint']['input']>;
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetInvoiceSidebarAmountDueQuery = { __typename?: 'query_root', arinvoices: Array<{ __typename?: 'arinvoices', id: number, amount_due_argroups: Array<{ __typename?: 'argroups', id: number, status: string, customer_id: number, program_id?: number | null, archarges: Array<{ __typename?: 'archarges', id: number, type: string, active: boolean, amount: number, source_type?: string | null, source_id?: number | null, arpaymentdetails: Array<{ __typename?: 'arpaymentdetails', amount: number, parent: { __typename?: 'arpayments', status: string } }> }>, arcredits: Array<{ __typename?: 'arcredits', id: number, amount: number, source_type?: string | null, source_id?: number | null }> }> }> };


export const GetInvoiceSidebarAmountDueDocument = gql`
    query getInvoiceSidebarAmountDue($rooftopId: bigint, $start: timestamptz!, $end: timestamptz!) {
  arinvoices(
    where: {customer_id: {_eq: $rooftopId}, _and: [{_or: [{start_datetime: {_gte: $start, _lte: $end}}, {end_datetime: {_gte: $start, _lte: $end}}]}, {_or: [{invoice_type: {_like: "%_charges"}}, {invoice_type: {_eq: "program"}}]}]}
  ) {
    id
    amount_due_argroups: argroups(where: {status: {_eq: "done"}}) {
      id
      status
      customer_id
      program_id
      archarges(where: {active: {_eq: true}}) {
        id
        type
        active
        amount
        source_type
        source_id
        arpaymentdetails {
          amount
          parent {
            status
          }
        }
      }
      arcredits(where: {active: {_eq: true}}) {
        id
        amount
        source_type
        source_id
      }
    }
  }
}
    `;

/**
 * __useGetInvoiceSidebarAmountDueQuery__
 *
 * To run a query within a React component, call `useGetInvoiceSidebarAmountDueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceSidebarAmountDueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceSidebarAmountDueQuery({
 *   variables: {
 *      rooftopId: // value for 'rooftopId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetInvoiceSidebarAmountDueQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables> & ({ variables: GetInvoiceSidebarAmountDueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>(GetInvoiceSidebarAmountDueDocument, options);
      }
export function useGetInvoiceSidebarAmountDueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>(GetInvoiceSidebarAmountDueDocument, options);
        }
// @ts-ignore
export function useGetInvoiceSidebarAmountDueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>;
export function useGetInvoiceSidebarAmountDueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceSidebarAmountDueQuery | undefined, GetInvoiceSidebarAmountDueQueryVariables>;
export function useGetInvoiceSidebarAmountDueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>(GetInvoiceSidebarAmountDueDocument, options);
        }
export type GetInvoiceSidebarAmountDueQueryHookResult = ReturnType<typeof useGetInvoiceSidebarAmountDueQuery>;
export type GetInvoiceSidebarAmountDueLazyQueryHookResult = ReturnType<typeof useGetInvoiceSidebarAmountDueLazyQuery>;
export type GetInvoiceSidebarAmountDueSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceSidebarAmountDueSuspenseQuery>;
export type GetInvoiceSidebarAmountDueQueryResult = Apollo.QueryResult<GetInvoiceSidebarAmountDueQuery, GetInvoiceSidebarAmountDueQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/invoices/queries/getInvoiceSidebarAmountDue.query.gql}
 */
export async function getInvoiceSidebarAmountDue(
  variables: GetInvoiceSidebarAmountDueQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetInvoiceSidebarAmountDueQuery['arinvoices']>
export async function getInvoiceSidebarAmountDue(
  variables: GetInvoiceSidebarAmountDueQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetInvoiceSidebarAmountDueQuery>
export async function getInvoiceSidebarAmountDue(
  variables: GetInvoiceSidebarAmountDueQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetInvoiceSidebarAmountDueQuery['arinvoices'] | GetInvoiceSidebarAmountDueQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetInvoiceSidebarAmountDueQuery>(
    GetInvoiceSidebarAmountDueDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.arinvoices
}